import { NgModule } from '@angular/core';
import { FormatCallProvidersPipe } from './format-providers-numbers.pipe';

@NgModule({
   declarations: [FormatCallProvidersPipe],
   exports: [FormatCallProvidersPipe],
})
export class FormatCallProvidersPipeModule {}
